import ILocationEndpoints from "./framework/ILocationEndpoints";
import EndpointsBaseClass from "apiConsumers/EndpointsBaseClass";
import CountryCode from "models/CountryCode";
import getLocationCountryCode from "utils/getLocationCountryCode";

export default class LocationEndpoints extends EndpointsBaseClass implements ILocationEndpoints {
    public async getIsoLocation(): Promise<CountryCode> {
        const response = await this.makeGetRequest(`location`);

        return this.convertIsoLoactionResponse(response);
    }

    private convertIsoLoactionResponse(response: any): CountryCode {
        const defaultLocation = CountryCode.GB;

        if (typeof response !== "string") return defaultLocation;

        return getLocationCountryCode(response, defaultLocation);
    }
}
